import React from "react";

export default function Tabs({
  tabs,
  activeId,
  onChange,
  className = "",
  ariaLabel,
  idPrefix = "tab",
}) {
  function onKeyDown(event, index) {
    if (event.key !== "ArrowRight" && event.key !== "ArrowLeft" && event.key !== "Home" && event.key !== "End") {
      return;
    }
    event.preventDefault();
    let nextIndex = index;
    if (event.key === "ArrowRight") nextIndex = (index + 1) % tabs.length;
    if (event.key === "ArrowLeft") nextIndex = (index - 1 + tabs.length) % tabs.length;
    if (event.key === "Home") nextIndex = 0;
    if (event.key === "End") nextIndex = tabs.length - 1;
    const nextTab = tabs[nextIndex];
    onChange(nextTab.id);
    document.getElementById(`${idPrefix}-${nextTab.id}`)?.focus();
  }

  return (
    <ul
      className={`nav bordered-tab border border-top-0 border-start-0 border-end-0 nav-pills agent-tabs ${className}`.trim()}
      role="tablist"
      aria-label={ariaLabel}
    >
      {tabs.map((tab, index) => {
        const active = activeId === tab.id;
        return (
          <li className="nav-item" role="presentation" key={tab.id}>
            <button
              type="button"
              id={`${idPrefix}-${tab.id}`}
              className={`nav-link px-16 py-10 ${active ? "active" : ""}`}
              role="tab"
              aria-selected={active}
              aria-controls={`${idPrefix}-panel-${tab.id}`}
              tabIndex={active ? 0 : -1}
              onClick={() => onChange(tab.id)}
              onKeyDown={(event) => onKeyDown(event, index)}
            >
              {tab.label}
            </button>
          </li>
        );
      })}
    </ul>
  );
}
